 export class OrderCancellationInfo {
   chargeableCancellation?: boolean;
   cancellationFee?: number;
   cancellationNotes?: string;
 }
